<template lang="pug">
.card.market-card.mmo
  .card-header.bg-more-head.collapse-more(
    :id="'heading-hdpoummo-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-hdpoummo-' + id"
    :aria-controls="'collapse-hdpoummo-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("ui.mmo_odds") }}
  .collapse.show(
    :aria-labelledby="'heading-hdpoummo-' + id"
    :id="'collapse-hdpoummo-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal
          .normal-odd-area
            .normal-odd-area-group
              .match-bet-area-type-title {{ $tc("m.BT_HDPF", 1) }}
              .d-flex
                .normal-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Home") }}
                template(v-if="Object.keys(mmoDetails).length > 0 && mmoDetails['tn'] > 0")
                  template(v-for="(dn, i) in mmoDetails['kns']")
                    .match-odd-area-group
                      template(v-if="mmoDetails['hdp'] && mmoDetails['hdp'][i] && mmoDetails['hdp'][i][9] != 0 && mmoDetails['hdp'][i][10] != 0 && mmoDetails['hdp'][i][9] != '' && mmoDetails['hdp'][i][10] != ''")
                        oddsItemMMOX(:odds="mmoDetails['hdp'][i]" :idx="mmoDetails['hdp'][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="mmoDetails" homeAway="1" pos=22)
                      template(v-else)
                        OddsDisabled
                template(v-else)
                  .match-odd-area-group
                    OddsDisabled
                .match-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Away") }}
                template(v-if="Object.keys(mmoDetails).length > 0 && mmoDetails['tn'] > 0")
                  template(v-for="(dn, i) in mmoDetails['kns']")
                    .match-odd-area-group
                      template(v-if="mmoDetails['hdp'] && mmoDetails['hdp'][i] && mmoDetails['hdp'][i][9] != 0 && mmoDetails['hdp'][i][10] != 0 && mmoDetails['hdp'][i][9] != '' && mmoDetails['hdp'][i][10] != ''")
                        oddsItemMMOX(:odds="mmoDetails['hdp'][i]" :idx="mmoDetails['hdp'][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="mmoDetails" homeAway="2" pos=22)
                      template(v-else)
                        OddsDisabled
                template(v-else)
                  .match-odd-area-group
                    OddsDisabled
            .normal-odd-area-group
              .match-bet-area-type-title {{ $tc("m.BT_OUF", 1) }}
              .d-flex
                .match-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Over") }}
                template(v-if="Object.keys(mmoDetails).length > 0 && mmoDetails['tn'] > 0")
                  template(v-for="(dn, i) in mmoDetails['kns']")
                    .match-odd-area-group
                      template(v-if="mmoDetails['ou'] && mmoDetails['ou'][i] && mmoDetails['ou'][i][11] != 0 && mmoDetails['ou'][i][12] != 0 && mmoDetails['ou'][i][11] != '' && mmoDetails['ou'][i][12] != ''")
                        oddsItemMMOX(:odds="mmoDetails['ou'][i]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="i" :details="mmoDetails" homeAway="1" pos=23)
                      template(v-else)
                        OddsDisabled
                template(v-else)
                  .match-odd-area-group
                    OddsDisabled
                .match-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Under") }}
                template(v-if="Object.keys(mmoDetails).length > 0 && mmoDetails['tn'] > 0")
                  template(v-for="(dn, i) in mmoDetails['kns']")
                    .match-odd-area-group
                      template(v-if="mmoDetails['ou'] && mmoDetails['ou'][i] && mmoDetails['ou'][i][11] != 0 && mmoDetails['ou'][i][12] != 0 && mmoDetails['ou'][i][11] != '' && mmoDetails['ou'][i][12] != ''")
                        oddsItemMMOX(:odds="mmoDetails['ou'][i]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="i" :details="mmoDetails" homeAway="2" pos=23)
                      template(v-else)
                        OddsDisabled
                template(v-else)
                  .match-odd-area-group
                    OddsDisabled
</template>

<script>
import oddsItemMMOX from "@/components/mobile/main/xitem/oddsItemMMOX";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    oddsItemMMOX,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>